<div class="row g-0">
  <div class="col-md-8">
    <h1>{{ pageTitle }}</h1>
    <p>{{ 'this_site_uses_cookies' | translate }}</p>
    <p>{{ 'browser_by_default' | translate }}</p>
  </div>
</div>
